import { SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH } from "./root";

export const SUBSCRIPTIONS_CUSTOMER_ADD_FRESH_PATH_SUFFIX = "/add";
/** /customer/subscription/fresh/add */
export const SUBSCRIPTIONS_CUSTOMER_ADD_FRESH_PATH = `${
  SUBSCRIPTIONS_CUSTOMER_FRESH_CONTROLLER_ROOT_PATH
}${
  SUBSCRIPTIONS_CUSTOMER_ADD_FRESH_PATH_SUFFIX
}`;
